import { render, staticRenderFns } from "./declaracao.vue?vue&type=template&id=6230b5ad&"
import script from "./declaracao.vue?vue&type=script&lang=js&"
export * from "./declaracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports